<style>
  section {
    padding: 8rem 1.5rem;
    border-top: 1px solid var(--separator);
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem;
    align-items: center;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  h2 {
    font-family: "Bodoni Moda", serif;
    font-size: 3rem;
    font-style: italic;
  }

  p {
    font-family: "Inter", sans-serif;
    color: var(--muted);
    font-size: 0.875rem;
    line-height: 1.625;
    letter-spacing: 0.025em;
  }

  .coordinates {
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--ink);
    margin-top: 1rem;
    border-left: 1px solid var(--separator);
    text-decoration: none;
  }

  .coordinates:hover {
    text-decoration: underline;
  }

  .image-content figure {
    width: 100%;
  }

  .image-content figure > div {
    aspect-ratio: 3/2;
    overflow: hidden;
  }

  figcaption {
    font-family: "Inter", sans-serif;
    color: var(--muted);
    font-size: 0.625rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-top: 0.75rem;
    text-align: right;
  }

  @media (min-width: 768px) {
    section {
      padding: 8rem 3rem;
    }

    .container {
      grid-template-columns: repeat(12, 1fr);
    }

    .text-content {
      grid-column: 1 / span 4;
    }

    .image-content {
      grid-column: 7 / span 6;
    }
  }

  @media (min-width: 1024px) {
    section {
      padding: 8rem 6rem;
    }
  }
</style>

<script>
  import EditorialImage from "./components/EditorialImage.svelte";

  let { lightboxItems = $bindable([]), openLightbox = $bindable(() => {}) } =
    $props();

  const imageFilename = "ring.jpg";
  const imageAlt = "The Ring";

  const imageIndex = lightboxItems.length;
  lightboxItems = [
    ...lightboxItems,
    {
      type: "image",
      filename: imageFilename,
      alt: imageAlt,
    },
  ];
</script>

<section>
  <div class="container">
    <div class="text-content">
      <h2>We're engaged!</h2>
      <p>
        Amy said "yes" on November 16, 2025 near our home on the west side of
        Manhattan.
      </p>
      <a class="coordinates" href="https://maps.app.goo.gl/ja5JmReYu7smRKJb7"
        >Pier 97, New York City</a
      >
    </div>
    <div class="image-content">
      <figure>
        <div>
          <EditorialImage
            filename={imageFilename}
            alt={imageAlt}
            aspectRatio="3/2"
            onclick={() => openLightbox(imageIndex)}
          />
        </div>
        <figcaption>The ring</figcaption>
      </figure>
    </div>
  </div>
</section>
